import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm, isEmail } from 'react-jhipster';
import { toast } from 'react-toastify';

import { locales, languages } from '../../../../../../app/config/translation';
import { useAppDispatch, useAppSelector } from '../../../../../../app/config/store';
import { getSession } from '../../../../app/shared/reducers/authentication';
import { saveAccountSettings, reset } from './settings.reducer';
import axios from 'axios';
import { useNavigate } from 'react-router';

export const SettingsPage = props => {
  const dispatch = useAppDispatch();
  const account = useAppSelector(state => state.authentication.account);
  const navigate = useNavigate();
  const [error, setError] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(false);
  const nameRef = useRef<any>(null);
  const [username, setUserName] = useState<any>(account?.login || '');
  // const successMessage = useAppSelector(state => state.settings.successMessage);
  useEffect(() => {
    dispatch(getSession());
    if (props?.showModal) {
      setTimeout(() => nameRef.current?.focus(), 100);
      setUserName(account?.login);
      setError(prevErrors => ({
        ...prevErrors,
        ['userName']: '',
      }));
    }
    return () => {
      dispatch(reset());
    };
  }, [props.showModal]);

  const validate = () => {
    if (username == '') {
      setError(prevErrors => ({
        ...prevErrors,
        ['userName']: 'Please enter username ',
      }));
      return true;
    } else {
      return false;
    }
  };

  const handleValidSubmit = async e => {
    e.preventDefault();
    if (validate()) return;
    try {
      setLoader(true);
      const api = `api/update-user/${username}`;
      const response = await axios.put(api);
      if (response?.data?.status == 'success') {
        toast.success('Username updated. Logging out.....', { position: 'top-right' });
        setLoader(false);
        setTimeout(() => {
          navigate('/logout');
        }, 800);
      } else {
        toast.success(response?.data?.message, { position: 'top-right' });
        setLoader(false);
      }
    } catch (error) {
      toast.error('Something went wrong', {
        position: 'top-right',
      });
    }
  };

  const handleClose = () => {
    props?.toggle();
  };

  return (
    <div>
      <Modal isOpen={props?.showModal} toggle={() => handleClose()} centered className="user-settings-modal">
        <ModalHeader
          toggle={() => {
            props?.toggle(), setUserName(account?.login);
          }}
        >
          User Settings
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleValidSubmit}>
            <FormGroup>
              <Label for="userName">Name</Label>
              <Input
                type="text"
                id="userName"
                value={username}
                onChange={e => setUserName(e.target.value.replace(/\s/g, ''))}
                innerRef={nameRef}
                invalid={!!error['userName']}
              />
              <FormFeedback>{error['userName']}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="userEmail">Email</Label>
              <Input type="email" id="userEmail" value={account?.email} disabled />
            </FormGroup>
            {/* <FormGroup>
              <Label for="userPassword">Password</Label>
              <div className="position-relative">
                <Input type={showPassword ? 'text' : 'password'} id="userPassword" placeholder="**********" disabled />
                <Button size="sm" className="view-password" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? 'Hide' : 'View'}
                </Button>
              </div>
            </FormGroup> */}
            <ModalFooter>
              <Button type="submit" className="save-btn" disabled={loader}>
                Save changes
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SettingsPage;
